"use client"

import * as LabelPrimitive from "@radix-ui/react-label"
import * as React from "react"

import * as styles from "./label.styled"

const Label = React.forwardRef<
  React.ComponentRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root ref={ref} className={styles.label(className)} {...props} />
))
Label.displayName = LabelPrimitive.Root.displayName

export { Label }
